import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { DataService } from "src/app/services/data.service";
import { NotificationService } from "src/app/services/notification-service/notification.service";
import { createLicence, createLicenceFailure, createLicenceSuccess, deleteLicence, deleteLicenceFailure, deleteLicenceSuccess, getLicence, getLicenceFailure, getLicenceSuccess } from "../actions/licence.action";
import { catchError, concatMap, exhaustMap, map, of, take, tap } from "rxjs";
import { Router } from "@angular/router";

@Injectable()
export class LicenceEffect {

  loadLicences$ = createEffect(() => this.actions$.pipe(
    ofType(getLicence),
    exhaustMap(({ element, page, size, utilisateurId }) => this.dataService.loadLicenceData(element, page, size, utilisateurId).pipe(
      map((responseDAO) => getLicenceSuccess(responseDAO)),
      catchError((error) => of(getLicenceFailure(error)))
    ))
  ))

  createLicence$ = createEffect(() => this.actions$.pipe(
    ofType(createLicence),
    concatMap(({ licence }) => this.dataService.createObject("Licence", licence).pipe(
      map((reponseDAO) => createLicenceSuccess(reponseDAO)),
      catchError((error) => of(createLicenceFailure(error)))
    )),
    tap((action) => {
      if (action.type == "[Licence] Create licence Success") {
        this.notificationService.success("Licence créé avec succès")
        this.router.navigate(["manage-licence"])
      }
    })
  ))

  deleteLicence$ = createEffect(() => this.actions$.pipe(
    ofType(deleteLicence),
    concatMap(({ id }) => this.dataService.deleteLicence(id).pipe(
      map(() => deleteLicenceSuccess()),
      catchError((error) => of(deleteLicenceFailure({ error })))
    )
    ),
    tap((action) => {
      if (action.type === "[Licence] Delete Licence Success") {
        this.notificationService.success("Licence supprimée")
      } else {
        this.notificationService.error("Erreur lors de la suppression de la licence")
      }
    })
  ))

  constructor(private notificationService: NotificationService, private actions$: Actions, private dataService: DataService, private router: Router) { }
}
